import { Distributor } from './Distributor';

export type UpdateDistributor = Omit<Distributor, 'id'> & {
    distributorId: string;
};

export const defaultUpdateDistributor: UpdateDistributor = {
    distributorId: '',
    name: '',
    email: '',
    notes: '',
};
